module.exports = __webpack_public_path__ + "static/media/square.6b0d1c3d.svg";